import { constants } from 'lib_ui-services';
import padMarkText from './padMarkText';

const { useCaseIds } = constants;

export default {
    verb: 'willMark',
    namespace: 'item',
    relation: 'item',
    description: 'Left pad markText to the tag length this tenant uses, keeping the entered value to match on too',
    useCaseIds: [useCaseIds.PALM],
    logic: willMark
};

/**
 * Not every PALM agency uses the full 8 character tag length, and an asset imported with a
 * 3 digit tag number is stored with that short value. Padding the entry to `00000123` and
 * searching for only that would never find it, so keep the entered value in
 * `alternateMarkTexts` for the lookup to fall back to (see `markTextMatching`).
 * FLAIR has its own rule and keeps searching on the padded value alone.
 * @param {{data: object, context: object}} parameters
 * @returns {object} data
 */
function willMark({ data, context }) {
    const paddedMarkText = padMarkText(data?.markText, context);
    //nothing was padded, so there is no second value to look for
    if (paddedMarkText === data?.markText) return data;

    data.originalMarkText = data.markText;
    data.alternateMarkTexts = [data.markText];
    data.markText = paddedMarkText;
    return data;
}
